export enum LeaderboardScoringMode {
	Sum = 'sum',
	Average = 'average',
}
